export default __webpack_public_path__ + "static/Vania-2d2da2293a889acf788eef136b477cac8c0254957fefe0e32cf6bf614192ed5d.svg";